export let STYLE_STORE = Object.create(null);
export let ATTRS_STORE = Object.create(null);
export let MEDIA_STORE = Object.create(null);
export let CSS_STORE = Object.create(null);

CSS_STORE.MEDIA = {};

const _STORE_ = {
    STYLE_STORE,
    ATTRS_STORE,
    MEDIA_STORE,
    CSS_STORE,
};

export default _STORE_;
